import { Component, inject, OnInit, Signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { loadPayerServices, loadPayment } from '../../../../store/actions/my-bills.actions';
import { Store } from '@ngrx/store';
import {
  selectLoading, selectPayerData,
  selectPayment,
  selectPaymentComponentByIdZap
} from '../../../../store/selectors/my-bills.selectors';
import { SigIdPaymentComponentRead, SigIdPaymentRead } from '../../../../services/sig-id.common.model';
import { BreadcrumbsComponent } from '../../../../common/breadcrumbs/breadcrumbs.component';
import { ContentComponent } from '../../../../components/content/content.component';
import { SpinnerComponent } from '../../../../common/spinner/spinner.component';
import { LabelComponent } from '../../../../common/label/label.component';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { ToNumberPipe } from '../../../../pipes/to-number.pipe';
import { JoinPipe } from '../../../../pipes/join.pipe';
import { CopyToClipboardDirective } from '../../../../directives/copy-to-clipboard.directive';
import { calcItemTotalAmount, ItemTotalAmountPipe } from '../../pipes/item-total-amount.pipe';
import { PaymentCommonService } from '../../../../services/payment.common.service';
import { environment } from '../../../../../environments/environment';
import { SessionService } from '../../../../services/ssession.service';
import { SigidPayerServiceData } from '../../../../openapi';

@Component({
  selector: 'app-my-bills-payment-details-page',
  standalone: true,
  imports: [
    BreadcrumbsComponent,
    ContentComponent,
    RouterLink,
    SpinnerComponent,
    LabelComponent,
    CurrencyPipe,
    ToNumberPipe,
    JoinPipe,
    DatePipe,
    CopyToClipboardDirective,
    ItemTotalAmountPipe
  ],
  templateUrl: './my-bills-payment-details-page.component.html'
})
export class MyBillsPaymentDetailsPageComponent implements OnInit {

  public currentDate: Date = new Date();

  private route: ActivatedRoute = inject(ActivatedRoute);

  private store$: Store = inject(Store);

  private paymentCommonService: PaymentCommonService = inject(PaymentCommonService);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  private identSigId: string = this.route.snapshot.params['identSigId'];

  private serviceCode: string = this.route.snapshot.params['serviceCode'];

  private idZap: string = this.route.snapshot.params['idZap'];

  private baseReturnUrl: string = `${environment.ssl ? 'https' : 'http'}://${window.location.host}/moje-oplaty/status-platnosci/${this.identSigId}/${this.serviceCode}`;

  public payerData: Signal<SigidPayerServiceData | null> = this.store$.selectSignal(selectPayerData(this.identSigId));

  public payment: Signal<SigIdPaymentRead | null> = this.store$.selectSignal(selectPayment);

  public paymentComponent: Signal<SigIdPaymentComponentRead | null> = this.store$.selectSignal(selectPaymentComponentByIdZap(this.idZap));

  public payClicked = false;

  public goToPay(item: SigIdPaymentComponentRead): void {
    this.payClicked = true;
    this.paymentCommonService.goToPay({
      returnUrl: this.baseReturnUrl + '/' + item?.idZap,
      accountNumberOverride: this.payment()?.service?.accountNumber || undefined,
      clientEmail: SessionService.GetTokenData()?.email || '',
      clientFirstName: SessionService?.GetTokenData()?.firstName || '',
      clientLastName: SessionService?.GetTokenData()?.lastName || '',
      descriptionOverride: `${this.payment()?.service?.code || ''}, ${this.payerData()?.fullName || ''} - ${this.identSigId}`,
      totalAmount: calcItemTotalAmount(item)
    }).subscribe({
      next: result => {
        this.payClicked = false;
      },
      error: error => {
        this.payClicked = false;
      }
    });
  }

  private loadPaymentDetails(): void {
    this.store$.dispatch(loadPayment({
      identSigId: this.identSigId,
      serviceCode: this.serviceCode,
      idZap: this.idZap
    }));
  }

  public ngOnInit(): void {
    this.store$.dispatch(loadPayerServices({}));
    this.loadPaymentDetails();
  }
}
